import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";

export const setNewPasswordApi = createApi({
  reducerPath: "setNewPasswordApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BASE_API_URL,
  }),
  tagTypes: ["SetNewPassword"],
  endpoints: (builder) => ({
    resetPassword: builder.mutation({
      query: ({ userId, newPassword, sessionId }) => ({
        url: apiurl.ResetPassword, // "/resetPassword"
        method: "POST",
        body: { userId, newPassword, sessionId },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["SetNewPassword"],
    }),
  }),
});

export const { useResetPasswordMutation } = setNewPasswordApi;
